var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32,
    r: 32,
    fill: "#DDE1FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4999 52.0677C21.4344 52.0677 12.4321 43.0654 12.4321 31.9999C12.4321 20.9344 21.4344 11.9321 32.4999 11.9321C43.5654 11.9321 52.5677 20.9344 52.5677 31.9999C52.5677 43.0654 43.5654 52.0677 32.4999 52.0677Z",
    fill: "#98A3FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5003 12.4749C43.2664 12.4749 52.0257 21.2342 52.0257 32.0003C52.0257 42.7664 43.2664 51.5257 32.5003 51.5257C21.7342 51.5257 12.9749 42.7664 12.9749 32.0003C12.9749 21.2342 21.7342 12.4749 32.5003 12.4749ZM32.5003 11.3901C21.1181 11.3901 11.8901 20.6181 11.8901 32.0003C11.8901 43.3825 21.1181 52.6105 32.5003 52.6105C43.8825 52.6105 53.1105 43.3825 53.1105 32.0003C53.1105 20.6181 43.8825 11.3901 32.5003 11.3901Z",
    fill: "#4756D1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7373 32L29.2458 38.5084L43.3475 24.4067",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessMark);
export default __webpack_public_path__ + "static/media/success-mark.423abc5b.svg";
export { ForwardRef as ReactComponent };